import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SearchBar({ initialValue = '', placeholder = 'Search by title, author, or subject...', autoFocus = false }) {
  const [query, setQuery] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q) {
      navigate(`/search?q=${encodeURIComponent(q)}`);
    }
  };

  const suggestions = [
    'Pride and Prejudice',
    'Sherlock Holmes',
    'Jules Verne',
    'Shakespeare',
    'Mark Twain',
    'Philosophy',
  ];

  const handleSuggestion = (s) => {
    setQuery(s);
    navigate(`/search?q=${encodeURIComponent(s)}`);
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        {/* Search icon */}
        <span className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </span>

        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
          className="w-full bg-primary/80 border-2 border-border rounded-2xl pl-14 pr-36
                     py-4 text-white text-lg placeholder-gray-500
                     focus:outline-none focus:ring-0 focus:border-accent
                     transition-all duration-300 hover:border-accent/50
                     backdrop-blur-sm"
          aria-label="Search books"
        />

        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2
                     bg-accent hover:bg-accent-light text-white font-bold
                     px-6 py-2.5 rounded-xl transition-all duration-200
                     hover:shadow-lg hover:shadow-accent/40 active:scale-95"
          aria-label="Search"
        >
          Search
        </button>
      </form>

      {/* Quick suggestions */}
      <div className="flex flex-wrap items-center gap-2 mt-4 justify-center">
        <span className="text-gray-500 text-sm">Try:</span>
        {suggestions.map((s) => (
          <button
            key={s}
            onClick={() => handleSuggestion(s)}
            className="text-sm text-gray-400 hover:text-accent border border-border/60
                       hover:border-accent/60 px-3 py-1 rounded-full
                       transition-all duration-200 hover:bg-accent/10"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SearchBar;
